<div class="space-y-8" [formGroup]="form()">
  <section class="space-y-5">
    <div>
      <h3 class="text-sm font-bold text-slate-900">UDS / Land Value</h3>
      <p class="mt-0.5 text-sm text-slate-500">Enter the underlying land ownership information for this property.</p>
    </div>

    <div class="grid gap-6 sm:grid-cols-2">
      <ui-input [control]="form().controls.udsSqft" label="UDS" type="number" suffix="sq.ft" />
      <ui-input
        [control]="form().controls.currentRatePsf"
        label="Current Rate per Sq.ft for UDS"
        type="number"
        prefix="₹"
      />
    </div>

    <div class="grid gap-4 sm:grid-cols-2">
      <ui-calculated-box
        label="Adjusted Current Value of UDS"
        [value]="adjustedUdsValue()"
        derivation="UDS × Current Rate per Sq.ft"
      />
      <ui-calculated-box
        label="UDS Support %"
        [value]="udsSupportPct()"
        derivation="Share of the quoted value supported by underlying land."
      />
    </div>
  </section>

  <div class="h-px bg-slate-200"></div>

  <section class="space-y-5">
    <div>
      <h3 class="text-sm font-bold text-slate-900">Rental Analysis</h3>
    </div>

    <div class="grid gap-6 sm:grid-cols-2">
      <ui-input [control]="form().controls.monthlyRent" label="Average Rent Per Month" type="number" prefix="₹" />
      <ui-calculated-box label="Average Rent PA" [value]="annualRent()" derivation="Monthly Rent × 12" />
    </div>

    <div class="grid gap-4 sm:grid-cols-2">
      <ui-calculated-box label="Rental Yield" [value]="rentalYieldPct()" derivation="Annual Rent ÷ Quoted Price" />
    </div>

    <label class="flex cursor-pointer items-center gap-2.5 text-sm text-slate-700">
      <input
        type="checkbox"
        formControlName="overrideRentalYield"
        class="size-4 rounded border-slate-300 accent-indigo-600"
      />
      Manually override rental yield
    </label>

    @if (form().controls.overrideRentalYield.value) {
      <div class="sm:max-w-sm">
        <ui-input
          [control]="form().controls.manualRentalYieldPct"
          label="Rental Yield (override)"
          type="number"
          suffix="%"
        />
      </div>
    }
  </section>

  <div class="h-px bg-slate-200"></div>

  <section class="space-y-4">
    <h3 class="text-sm font-bold text-slate-900">Trophy Override</h3>
    <p class="text-sm text-slate-700">Is this a genuinely scarce or trophy-quality property?</p>

    <div class="inline-flex overflow-hidden rounded-lg border border-slate-200">
      <button
        type="button"
        (click)="form().controls.trophyOverride.setValue(false)"
        class="px-5 py-2 text-sm font-semibold transition-colors"
        [class]="
          !form().controls.trophyOverride.value
            ? 'bg-indigo-600 text-white'
            : 'bg-white text-slate-600 hover:bg-slate-50'
        "
      >
        No
      </button>
      <button
        type="button"
        (click)="form().controls.trophyOverride.setValue(true)"
        class="px-5 py-2 text-sm font-semibold transition-colors"
        [class]="
          form().controls.trophyOverride.value
            ? 'bg-indigo-600 text-white'
            : 'bg-white text-slate-600 hover:bg-slate-50'
        "
      >
        Yes
      </button>
    </div>
  </section>
</div>
